module.exports = __webpack_public_path__ + "media/images/icons/form_add_social_media-afc54aedb703b444271f09d1d3c4a1a9.svg";